import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LanguageModel from '@/views/Language/models/language'

@Component({})
export default class Languages extends Mixins<MixinInterface>() {
    @Prop({ default: false }) dense!: boolean

    get languages() {
        return this.$store.getters.translationLanguages
    }

    get activeLanguages() {
        return this.$store.getters.activeLanguages
    }

    set activeLanguages(data: Array<string>) {
        this.$store.commit('activeLanguages', data)
    }

    async postLanguage() {
        await LanguageModel.initPost()
    }
}
